import { render } from "./CadastroLicenca.vue?vue&type=template&id=0bb40286&scoped=true"
import script from "./CadastroLicenca.vue?vue&type=script&lang=ts"
export * from "./CadastroLicenca.vue?vue&type=script&lang=ts"

import "./CadastroLicenca.vue?vue&type=style&index=0&id=0bb40286&lang=scss"
import "./CadastroLicenca.vue?vue&type=style&index=1&id=0bb40286&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0bb40286"

export default script